import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	PROJECT_CATEGORY_FEATURE_KEY,
	ProjectCategoryState,
	ProjectCategoryPartialState,
	projectCategoryAdapter
} from './project-category.reducer';

// Lookup the 'ProjectCategory' feature state managed by NgRx
export const getProjectCategoryState = createFeatureSelector<
	ProjectCategoryPartialState,
	ProjectCategoryState
>(PROJECT_CATEGORY_FEATURE_KEY);

const { selectAll, selectEntities } = projectCategoryAdapter.getSelectors();

export const getProjectCategoryLoaded = createSelector(
	getProjectCategoryState,
	(state: ProjectCategoryState) => state.loaded
);

export const getProjectCategoryError = createSelector(
	getProjectCategoryState,
	(state: ProjectCategoryState) => state.error
);

export const loadingProjectCategory = createSelector(
	getProjectCategoryState,
	(state: ProjectCategoryState) => state.loaded
);

export const getAllProjectCategory = createSelector(
	getProjectCategoryState,
	(state: ProjectCategoryState) => selectAll(state)
);

export const getProjectCategoryEntities = createSelector(
	getProjectCategoryState,
	(state: ProjectCategoryState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getProjectCategoryState,
	(state: ProjectCategoryState) => state.selectedProjectCategoryId
);

export const getSelected = createSelector(
	getProjectCategoryEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
